import { IRootState } from 'app/shared/reducers';
import { getDate } from 'app/shared/util/date-utils';
import { upperCaseFirstLetter } from 'app/shared/util/methode-util';
import { createSelector } from 'reselect';
import { ClaimState } from './state';

const selectClaimtState = (state: IRootState) => state.claim;

export const getClaimsList = createSelector<IRootState, ClaimState, any>(selectClaimtState, (claim: ClaimState) =>
  (claim.claimsList || []).map(el => ({
    subscriptionNumber: el.subscriptionNumber,
    subscriber: `${el.subscriber?.firstName} ${el.subscriber?.lastName}`,
    duration: `${getDate(el?.startDate || el?.declarationDate || '')}`,
    selled: `${el?.sellingPoint?.name || ''} `,
    subscriptionStatus: el?.status,
    claimNumber: el?.claimNumber,
    sku: el.sku,
    statusClaim: `${el?.status?.longLabel || el?.claimStatus?.label || ''}`,
    coverclaim: `${el?.cover?.longLabel || el?.cover?.label || ''}`,
    status: el?.claimStatus || el?.status,
    damagedGoods: el?.damagedGoods,
  }))
);

export const getFullClaimsListForContract = createSelector<IRootState, ClaimState, any>(selectClaimtState, (claim: ClaimState) =>
  (claim.claimListForContract || []).map(el => ({
    subscriptionNumber: el.subscriptionNumber,
    subscriber: `${el.subscriber?.firstName} ${el.subscriber?.lastName}`,
    duration: `${getDate(el?.startDate || el?.declarationDate || '')}`,
    selled: `${el?.sellingPoint?.name || ''} `,
    subscriptionStatus: el?.status,
    claimNumber: el?.claimNumber,
    sku: el.sku,
    statusClaim: `${el?.status?.longLabel || el?.claimStatus?.label || ''}`,
    coverclaim: `${el?.cover?.longLabel || el?.cover?.label || ''}`,
    status: el?.claimStatus || el?.status,
    damagedGoods: el?.damagedGoods,
  }))
);

export const getFullClaimsList = createSelector<IRootState, ClaimState, any>(selectClaimtState, (claim: ClaimState) =>
  (claim.claimListForContract || []).map(el => ({
    subscriptionNumber: el.subscriptionNumber,
    subscriber: `${el.subscriber?.firstName}` || '',
    duration: `Du ${getDate(el.startDate || '')} Au ${getDate(el.endDate || '')}`,
    selled: `${el?.sellingPoint?.name || ''} - ${el?.seller?.lastName || ''}`,
    subscriptionStatus: el.status,
    claimNumber: el.claimNumber,
    sku: el.sku,
    status: el.claimStatus?.label,
    fullStatus: el.claimStatus,
    dommage: el.cover?.label,
    occurenceDate: getDate(el.occurenceDate),
    declarationDate: getDate(el.declarationDate),
    damagedGoods: el?.damagedGoods || [],
  }))
);

export const getFullClaimsListMobile = createSelector<IRootState, ClaimState, any>(selectClaimtState, (claim: ClaimState) =>
  (claim.fullClaimList || []).map(el => ({
    subscriptionNumber: el.subscriptionNumber,
    subscriber: `${el.subscriber?.firstName}` || '',
    duration: `Du ${getDate(el.startDate || '')} Au ${getDate(el.endDate || '')}`,
    selled: `${el?.sellingPoint?.name || ''} - ${el?.seller?.lastName || ''}`,
    subscriptionStatus: el.status,
    claimNumber: el.claimNumber,
    sku: el.sku,
    status: el.claimStatus?.label,
    fullStatus: el.claimStatus,
    dommage: el.cover?.label,
    occurenceDate: getDate(el.occurenceDate),
    declarationDate: getDate(el.declarationDate),
    damagedGoods: el?.damagedGoods || [],
  }))
);

export const getEventsList = (claim: ClaimState) => {
  const finalItems = [];

  const itemsWhithTraking = [];
  const itemsWhithNotTraking = [];

  (claim?.claimModel?.claimEvent || []).map(el => {
    const item = {
      date: getDate(el.eventDate),
      dateValue: new Date(el.eventDate).getTime(),
      status: `${el.eventType?.shortLabel}` || '',
      detailsStatus: `${el.eventType?.longLabel}` || '',
      code: el.eventType?.code || '',
      generationLink: el.eventVariablePart,
    };

    if (item.code !== 9) {
      if (item !== null || item !== undefined) {
        finalItems?.push(item);
      }
    }
    if (item.code === 9) {
      if (item.generationLink.includes('trackingNumber')) {
        itemsWhithTraking.push(item);
      } else {
        itemsWhithNotTraking.push(item);
      }
    }
  });

  if ((itemsWhithTraking || [])?.length >= 0) {
    const x = (itemsWhithTraking.filter(
      e =>
        e.dateValue ===
        Math.max?.apply(
          Math,
          itemsWhithTraking.map(function (o) {
            return o.dateValue;
          })
        )
    ) || [])[0];
    if (x !== null || x !== undefined) {
      finalItems?.push(x);
    }
  } else {
    const y = (itemsWhithNotTraking.filter(
      e =>
        e.dateValue ===
        Math.max?.apply(
          Math,
          itemsWhithNotTraking.map(function (o) {
            return o.dateValue;
          })
        )
    ) || [])[0];
    if (y !== null || y !== undefined) {
      finalItems?.push(y);
    }
  }
  return finalItems.filter(e => e !== undefined).sort((a, b) => b.dateValue - a.dateValue);
}

export const getEvent = createSelector<IRootState, ClaimState, any>(selectClaimtState, (claim: ClaimState) => {
  return getEventsList(claim);
});

export const getUserInfoSelector = createSelector<IRootState, ClaimState, any>(selectClaimtState, (claim: ClaimState) => ({
  fullName: `${upperCaseFirstLetter(claim?.claimModel?.subscription?.subscriber?.firstName?.toLowerCase()) || ''} ${upperCaseFirstLetter(claim?.claimModel?.subscription?.subscriber?.lastName?.toLowerCase()) || ''
    }`,
  firstName: claim?.claimModel?.subscription?.subscriber?.firstName,
  lastName: claim?.claimModel?.subscription?.subscriber?.lastName,
  dateBirth: getDate(claim?.claimModel?.subscription?.subscriber?.birthdate || ''),
  placeBirth: `${claim?.claimModel?.subscription?.subscriber?.placeOfBirth || ''}`,
  street: claim?.claimModel?.subscription?.subscriber?.address?.address || '',
  streetNumber: claim?.claimModel?.subscription?.subscriber?.address?.streetNumber || '',
  additionalAddress: claim?.claimModel?.subscription?.subscriber?.address?.additionalAddress || '',
  codePostal: claim?.claimModel?.subscription?.subscriber?.address?.zipCode || '',
  city: claim?.claimModel?.subscription?.subscriber?.address?.city || '',
  email: claim?.claimModel?.subscription?.subscriber?.email || '',
  phone: claim?.claimModel?.subscription?.subscriber?.phoneNumber || claim?.claimModel?.subscription?.subscriber?.phone || '',
  mobileNumber: claim?.claimModel?.subscription?.subscriber?.mobileNumber || '',

  purchaseStore: `${claim?.claimModel?.subscription?.insuredGoods[0]?.purchaseStore?.label || ''}`,
}));

export const getClaimState = createSelector<IRootState, ClaimState, any>(selectClaimtState, (claim: ClaimState) => ({
  loading: claim?.loading,
  subscriptionSelected: claim?.claimModel?.subscription,
  redirect: claim?.redirect,
  listDocs: claim?.claimModel?.paperAndDocument,
  claimSelected: claim?.claimModel?.claim,
  benefit: claim?.claimModel?.benefit,
  claimCriteria: claim?.claimModel?.claimCriteria,
}));

export const getSocAndPiece = createSelector<IRootState, ClaimState, any>(selectClaimtState, (claim: ClaimState) => {
  return claim.claimModel.paperAndDocument;
});
